import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CONTENTBOX_PATCH } from '../common/constants';
import { capitalizeFirstLetter } from '../utils/string';
const priceDown = require('../../assets/icons/price_down.svg');

interface Props {
  patch?: string | null;
  discountPercentage?: number;
}

export const SimplePatch: FunctionComponent<Props> = ({ patch, discountPercentage }) => {
  const normalizedPatch = patch?.replace(/\s/g, '');
  if ((discountPercentage == undefined && !normalizedPatch) || !normalizedPatch) return null;
  const { t } = useTranslation('sharedComponents');

  const patchConfig = {
    [CONTENTBOX_PATCH.PROMO]: (
      <StyledPromo className="patch">
        {discountPercentage !== undefined ? <>-{Math.abs(discountPercentage)}%</> : capitalizeFirstLetter(t(`shared.patch.${normalizedPatch}`))}
      </StyledPromo>
    ),
    [CONTENTBOX_PATCH.NEW]: <StyledNew className="patch">{capitalizeFirstLetter(t(`shared.patch.${normalizedPatch}`))}</StyledNew>,
    [CONTENTBOX_PATCH.BESTSELLER]: <StyledBestseller className="patch">{capitalizeFirstLetter(t(`shared.patch.${normalizedPatch}`))}</StyledBestseller>,
    [CONTENTBOX_PATCH.PRICEDOWN]: (
      <StyledPriceDown className="patch">
        {capitalizeFirstLetter(t(`shared.patch.${normalizedPatch}`))}
        <StyledPriceDownImg src={priceDown} />
      </StyledPriceDown>
    ),
    [CONTENTBOX_PATCH.OUTOFSTOCK]: <StyledOutOfStock className="patch">{capitalizeFirstLetter(t(`shared.patch.${normalizedPatch}`))}</StyledOutOfStock>,
    [CONTENTBOX_PATCH.FLASH]: <StyledFlash className="patch">{t(`shared.patch.${normalizedPatch}`)}</StyledFlash>
  };

  return (
    <>
      <StyledContainer className={'patch-container ' + `patch-${normalizedPatch.toLowerCase()}`}>
        {!!normalizedPatch ? patchConfig[normalizedPatch] : null}
      </StyledContainer>
      {[CONTENTBOX_PATCH.PROMO, CONTENTBOX_PATCH.FLASH].includes(normalizedPatch) && (
        <style>{`.patch-promo ~ .patch-new, .patch-flash ~ .patch-new {display:none}`}</style>
      )}
    </>
  );
};

const StyledContainer = styled.div`
  white-space: nowrap;
  position: absolute;
  left: 8px;
  top: 8px;
  z-index: 999;
`;

const PatchBase = styled.div`
  font-weight: bold;
  font-size: 10px;
  line-height: initial;
  padding: 6px 12px;
  border-radius: 20px;
  color: #fff;
  background: #d62020;
`;

const StyledPromo = styled(PatchBase)`
  background: #d62020;
`;

const StyledNew = styled(PatchBase)`
  background: #01be67;
`;

const StyledPriceDownImg = styled.img`
  &&& {
    margin-left: 2px;
    height: 8px;
    width: 14px;
    padding-right: 3px;
  }
`;

const StyledFlash = styled(PatchBase)`
  text-transform: uppercase;
`;

const StyledPriceDown = styled(PatchBase)``;

const StyledOutOfStock = styled(PatchBase)`
  background: #676767;
`;

const StyledBestseller = styled(PatchBase)`
  background: #8264e1;
`;
